import { NavBar } from 'metrix-common3';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import IconList from '../../../icons';
import configs from './config.json';

const ProfileSideBar = (props) => {
    const intl = useIntl();

    const clickEventHandler = (value) => {
        if (value === 'policies') {
            window.location = '/';
        } else {
            props.setActiveTab(value);
            window.location.hash = value;
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        }
    };

    // Process the config to apply i18n
    const processConfigForI18n = (menuItems) => {
        if (!menuItems || !Array.isArray(menuItems)) {
            return [];
        }

        // Deep clone the menu items to avoid modifying the original
        const localizedMenuItems = JSON.parse(JSON.stringify(menuItems));

        // Update each menu item with the translated label
        return localizedMenuItems.map((item) => {
            // Use the intl.formatMessage to get the translated string
            item.label = intl.formatMessage({
                id: `Profile_SideBar.${item.code}`,
                defaultMessage: item.label, // Fallback to original label if translation not found
            });
            return item;
        });
    };

    const product = props.policy?.product || props.policySummary?.product;
    const policySchemaProductCode = props.policy?.policySchemaProductCode;
    let tabs = [];
    let defaultTab = '';
    const isAPILogsVisible = props.context.configuration.apiLogsVisibleToBroker;
    const isBroker = props.context.session.userType === 'broker';

    if (product) {
        const userConfig = configs.filter((config) => config.userType === props.context.session.userType)[0];

        if (userConfig?.menu) {
            let userMenu = [...userConfig.menu];

            // History tab is temporary hidden
            userMenu = userMenu.filter((config) => config.code !== 'history');

            if (isBroker && !isAPILogsVisible) {
                userMenu = userMenu.filter((config) => config.code !== 'logs');
            }

            // Hide underwriterCoverageAdjustment unless status is quoteAccepted and type is not certificate
            if (props.policySummary?.status !== 'quoteAccepted' || props.policy?.type === 'certificate') {
                userMenu = userMenu.filter((config) => config.code !== 'underwriterCoverageAdjustment');
            }

            // Hide testMode unless product is securemyoffer
            if (product?.toLowerCase() !== 'securemyoffer') {
                userMenu = userMenu.filter((config) => config.code !== 'testMode');
            }

            // Hide additionalSellers for certificates (only show for policies)
            if (props.policy?.type === 'certificate') {
                userMenu = userMenu.filter((config) => config.code !== 'securemyoffer.additionalSellers');
            }

            userMenu.forEach((config) => {
                if (config.code.includes('.')) {
                    const tabCode = config.code.split('.')[0];

                    if (policySchemaProductCode) {
                        if (tabCode === policySchemaProductCode.toLowerCase()) tabs.push(config);
                    } else {
                        if (tabCode === product.toLowerCase()) tabs.push(config);
                    }
                } else {
                    if (config.code === 'summary') {
                        defaultTab = 'summary';
                    }
                    tabs.push(config);
                }
            });

            tabs = processConfigForI18n(tabs);
        }
    }

    let tabName = window.location.hash;
    tabName = tabName.split('#')[1];
    if (tabName) {
        defaultTab = tabName;
    }

    useEffect(() => {
        if (!props.activeTab && defaultTab) {
            props.setActiveTab(defaultTab);
        }
    }, [props.activeTab, defaultTab, props.setActiveTab]);

    return (
        <React.Fragment>
            {props.policySummary && (
                <NavBar
                    tabs={tabs}
                    clickEvent={clickEventHandler}
                    defaultTab={defaultTab}
                    IconList={IconList}
                    validationInfo={props.validationInfo}
                />
            )}
        </React.Fragment>
    );
};

export default ProfileSideBar;
